// extracted by mini-css-extract-plugin
export var card = "_62-0";
export var failedIcon = "_62-4";
export var failedIconBadge = "_62-3";
export var icon = "_62-1";
export var successIcon = "_62-2";